window.CDApplyNewProductBuyCountryRules = (country) => {
  if (!country) return;

  document.documentElement.setAttribute('data-cd-country', country);

  const removeEl = (el) => {
    if (!el) return;
    const shopifySection = el.closest('.shopify-section');
    if (shopifySection) shopifySection.remove();
    else el.remove();
  };

  const reassurance = document.querySelector('[data-product-reassurance]');
  if (reassurance && country !== 'FR') {
    removeEl(reassurance);
  }

  const buy = document.querySelector('[data-product-buy]');
  if (!buy) return;

  const localBlock = buy.querySelector('[data-product-buy-local]');
  const usBlock = buy.querySelector('[data-product-buy-us]');

  const openUsRedirect = () => {
    const redirectNotification = document.getElementById('redirect_notification');
    if (!redirectNotification) return;
    redirectNotification.classList.remove('is-hidden');
    const closeBtn = redirectNotification.querySelector('.button');
    if (closeBtn) {
      closeBtn.addEventListener(
        'click',
        () => {
          redirectNotification.classList.add('is-hidden');
        },
        { once: true }
      );
    }
  };

  if (country === 'FR') {
    if (usBlock) usBlock.remove();
    return;
  }

  if (country === 'US') {
    if (localBlock) localBlock.remove();
    if (usBlock) {
      usBlock.hidden = false;
      const redirectBtn = usBlock.querySelector('[data-product-buy-redirect]');
      if (redirectBtn) redirectBtn.addEventListener('click', openUsRedirect);
    }
    return;
  }

  removeEl(buy);
};

(() => {
  const getSessionCookie = (cname) => {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return false;
  };

  const applyCountryRules = () => {
    const country = getSessionCookie('CD_COUNTRY');
    if (!country) return;

    const handleHeaderIcons = () => {
      const icons = [
        '.header__icon--account',
        '.header__icon--cart',
        '.header__menu--account',
        '.menu-drawer__header-account',
        '.menu-drawer__header-newsletter',
      ];
      for (let i = 0; i < icons.length; i++) {
        const el = document.querySelector(icons[i]);
        if (el) el.classList.remove('hidden');
      }
    };

    window.CDApplyNewProductBuyCountryRules(country);

    if (country === 'FR') {
      handleHeaderIcons();
      return;
    }

    const hideElements = (elements, parent) => {
      for (let i = 0; i < elements.length; i++) {
        const s = elements[i];
        if (parent) {
          const el = parent.querySelector(s);
          if (el) {
            el.style.pointerEvents = 'none';
            el.style.opacity = s === '.product-form__price' ? '0' : '0.2';
          }
        } else {
          const els = document.querySelectorAll(s);
          els.forEach((el) => {
            el.style.display = 'none';
          });
        }
      }
    };

    hideElements(['.product-card__price', '.product-card__form']);

    const productBar = document.querySelector('.page-enter-bar');
    if (productBar)
      hideElements(
        ['#product-variants-select', '.product-form__quantity', '.product-form__price'],
        productBar
      );

    const isUS = country === 'US';
    const hasThristie = document.getElementById('thirstie');
    const buyButton = document.querySelector('.product-form__buttons');

    // Remove empty price / stock display for available products on Thirstie in US version only
    if (isUS && hasThristie && productBar) {
      productBar.classList.remove('shouldBeHidden');
      const cantSell = document.querySelectorAll('.cantBeSelled');
      const priceZero = document.querySelectorAll('.is-price-zero');
      for (let i = 0; i < cantSell.length; i++) {
        cantSell[i].classList.remove('cantBeSelled');
      }
      for (let i = 0; i < priceZero.length; i++) {
        priceZero[i].classList.remove('is-price-zero');
      }
      if (buyButton) {
        const button = buyButton.querySelector('.product-form__submit');
        if (button && button.classList.contains('hasThirstie')) {
          button.disabled = false;
          button.querySelector('.action').innerHTML = 'Add to cart';
        }
      }
    }

    if (buyButton && isUS) {
      buyButton.addEventListener('click', (e) => {
        e.preventDefault();
        const redirectNotification = document.getElementById('redirect_notification');
        redirectNotification.classList.remove('is-hidden');
        redirectNotification.querySelector('.button').addEventListener(
          'click',
          () => {
            redirectNotification.classList.add('is-hidden');
          },
          'once'
        );
      });
    } else if (buyButton) {
      buyButton.style.pointerEvents = 'none';
      buyButton.style.opacity = '0.8';
      buyButton.querySelector('.button').disabled = true;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCountryRules);
  } else {
    applyCountryRules();
  }
})();
